module.exports = __webpack_public_path__ + "static/media/market_research_summary.840c4593.png";